import React from 'react';
import { HelpModalContentBody } from '@Components/HelpModal/HelpModal.style';
import { textblocks } from 'seal-ui-components';

const SettingsHelpModalContent = () => (
    <HelpModalContentBody>
        <textblocks.Heading3>Login Settings</textblocks.Heading3>

        <p>
            When you first start using DocuSign Analyzer in Office 365 you need to select which
            system to use. If you don&apos;t already have a system then you may add one.
        </p>

        <textblocks.Heading3>Selecting a System</textblocks.Heading3>
        <p>
            Systems are listed from the start if you have added at least one. If only one is present
            then that&apos;s your default system and you&apos;ll automatically login to that (if
            there still is an active session). Hovering a system will present what options you have
            for it – Login, Edit or Delete. You can always toggle a system&apos;s details if
            clicking on one.
        </p>

        <textblocks.Heading3>Adding a System</textblocks.Heading3>
        <p>
            Enter a name that can describe what it&apos;s used for. You also need to add a server
            address to where the DocuSign Analyzer add-in connects. Talk to your system
            administrator if you haven&apos;t got one.
        </p>

        <textblocks.Heading3>Login Preferences</textblocks.Heading3>
        <p>
            In DocuSign Analyzer you can choose how to login. Using Single Sign On means that
            you&apos;ll be able to sign in to your other applications that support SSO sign on as
            well (most often this is the preferred option). If you have credentials you may use
            those as well. Talk to your system administrator to learn more about this.
        </p>
    </HelpModalContentBody>
);

export default SettingsHelpModalContent;
